<template>
  <div
    v-if="visible"
    ref="formRef"
    class="magic-ui-container magic-ui-form"
  >
    <slot></slot>
    <magic-ui-component v-for="item in config.items" :key="item.id" :config="item"></magic-ui-component>
  </div>
</template>

<script lang="ts" setup>
import { computed, provide, reactive, Ref, ref, watch } from 'vue';
import { MComponent } from '@tmagic/schema';

import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay';

import MagicUiComponent from '../../../Component.vue';

import initValue from '../initValue';

const props = defineProps<{
  config: MComponent & (typeof initValue) & { items: MComponent[] };
}>();

const app = useApp(props);
const node = app?.page?.getNode(props.config.id!);

const formRef = ref<any>();
const values = reactive<any>({});

const defaultValues = reactive<any>({});
const validates = reactive<any>({});
const clearValidates = reactive<any>({})

provide('mFormValues', values);
provide('useFormField', (formFieldConfig: {
  fieldPropsConfig: {
    id: string | number;
    defaultValue?: any;

  };
  fieldValueRef: Ref<any>,
  validate: () => any;
  clearValidate: () => any;
}) => {
  const { fieldPropsConfig, fieldValueRef } = formFieldConfig;
  const prop = computed(() => {
    return fieldPropsConfig.id!;
  });
  watch(() => fieldPropsConfig.defaultValue, (val) => {
    defaultValues[prop.value] = val;
  }, {
    immediate: true,
  });
  watch(() => formFieldConfig.clearValidate, (val) => {
    clearValidates[prop.value] = val;
  }, {
    immediate: true,
  });
  
  watch(() => formFieldConfig.validate, (val) => {
    validates[prop.value] = val;
  }, {
    immediate: true,
  });

  watch(() => fieldValueRef.value, (val) => {
    values[prop.value] = val;
  }, {
    immediate: true,
  });
  watch(() => values[prop.value], (val) => {
    fieldValueRef.value = val;
  });
});

const validate = async () => {
  const values = Object.values(validates);
  let result;
  for(const validateFn of values) {
    result = await validateFn();
    if(!result) {
      return false;
    }
  }
  return true;
};

const emitSubmit = () => {
  console.log(`组件${props.config.id}的触发了submit事件并广播`)
  app?.emit('submit', node);
};

const submit = async () => {
  const result = await validate();
  if(result) {
    emitSubmit();
  }
};
const clearValidate = () => {
  Object.values(clearValidates).forEach(clearValidate => typeof clearValidate === 'function' && clearValidate())
};
const resetFields = () => {
  for(const key in defaultValues) {
    values[key] = defaultValues[key];
  }
  clearValidate();
};

const clearValues = () => {
  for (const key in values) {
    delete values[key];
  }
};



const setValues = (vals: any) => {
  for (const key in vals) {
    values[key] = vals[key];
  }
};

const {
  visible,
  show,
  hide,
} = useDisplay(props);

// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  visible,
  show,
  hide,
  values,
  submit,
  validate,
  setValues,
  resetFields,
  clearValues,
  clearValidate,
})

defineExpose(exportInterface);

</script>
